import { useQuery } from 'react-query';
import { baseApiUrl, fetcher, ServerErrorResponse } from 'data_sources/constants';
import { DraftPolicy } from 'views/App/Portal/Policy/_types/manuals/draft';

export const getDraftPolicy = async (manualId: string, policyId: string, staged?: boolean) => {
  let url = `${baseApiUrl()}/lexiverse/policies/v1/manuals/${manualId}/policies/${policyId}`;
  if (staged !== undefined) url += `?staged=${staged}`;
  const data = await fetcher({
    method: 'get',
    url,
  });
  return data;
};

export default function useDraftPolicy(
  manualId?: string,
  policyId?: string,
  staged: boolean = true,
  options = {},
  onError?: (errors: ServerErrorResponse) => void
) {
  return useQuery<DraftPolicy, Error>(
    ['draft_policy', manualId, policyId, staged],
    async () => {
      const data = await getDraftPolicy(manualId || '', policyId || '', staged || false);
      return data;
    },
    {
      ...options,
      enabled: !!policyId,
      keepPreviousData: false,
    }
  );
}
